export default "__VITE_ASSET__lU3Do02t__"